export enum IndividualMetricCharts {
    Performance = "performanceIndex",
    Development = "developmentIndex",
    Engagement = "engagementIndex",
    Followers = "followersIndex",
    PerformanceSpotfy = "performanceSpotify",
    FollowersCntSpotify = "followersCntSpotify",
    PopularitySpotify = "popularitySpotify",
    ViewsCntYoutube = "viewsCntYoutube",
    SubscribersCntYoutube = "subscribersCntYoutube",
    FollowersCntInstagram = "followersCntInstagram",
    LikesMedianInstagram = "likesMedianInstagram",
    CommentsMedianInstagram = "commentsMedianInstagram",
}